import React from 'react';
import { ExternalLink, AlertTriangle, LogOut } from 'lucide-react';
import usePermissionStore from '../../stores/permissionStore';

const StudentAccessPrompt = () => {
  const { user, logout } = usePermissionStore();

  const handleGoToStudentPortal = () => {
    window.location.href = 'https://i.sumarts.cn/login';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 text-center border border-gray-100">
        <div className="w-20 h-20 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertTriangle size={40} className="text-amber-500" />
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-2">访问受限</h2>
        <p className="text-gray-500 mb-8">
          亲爱的 <span className="font-semibold text-gray-900">{user?.username}</span>，
          您当前使用的是学生/家长账户。管理后台仅供老师和管理员使用。
        </p>

        <div className="space-y-4">
          <button
            onClick={handleGoToStudentPortal}
            className="w-full py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-2xl font-bold flex items-center justify-center gap-2 transition-all shadow-lg shadow-blue-100 group"
          >
            前往学生个人中心
            <ExternalLink size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </button>
          
          <button
            onClick={logout}
            className="w-full py-4 bg-gray-100 hover:bg-gray-200 text-gray-600 rounded-2xl font-bold flex items-center justify-center gap-2 transition-all"
          >
            退出登录
            <LogOut size={18} />
          </button>
        </div>

        <div className="mt-10 pt-8 border-t border-gray-100">
          <p className="text-sm text-gray-400">
            如果您是老师，请使用正确的账号登录或联系系统管理员。
          </p>
          <p className="text-[11px] text-gray-300 mt-2 font-mono">
            SUMARTS.CN
          </p>
        </div>
      </div>
    </div>
  );
};

export default StudentAccessPrompt;
